import React from 'react';
import { useTranslation } from 'react-i18next';
import { Currency, InlineButton, Typography, Card } from 'ui-components';
import { ReactComponent as PencilIcon } from 'common-assets/assets/icons/pencil.svg';
import useStyles from './SelectRecommendedFunds.style';

type Props = {
  initialAmount: number;
  monthlyAmount: number;
  onChooseInvestmentAmount: (type: 'first' | 'monthly') => void;
};

const PaymentCard: React.FC<Props> = ({ initialAmount, monthlyAmount, onChooseInvestmentAmount }) => {
  const c = useStyles({});
  const [t] = useTranslation('select-recommended-funds');

  return (
    <Card className={c.paymentCard}>
      <div className={c.paymentItem}>
        <Typography variant="body2" textColor="greys.60" className={c.paymentItemTitle}>
          {t('first_payment_value', 'First payment value')}
        </Typography>
        <Currency
          value={initialAmount}
          valueSize="xxl"
          valueFontWeight="extraBold"
          codeSize="xxl"
          codeFontWeight="extraBold"
          valueClassName={c.currency}
          codeClassName={c.currency}
        />
        <InlineButton
          variant="underline"
          customIcon={<PencilIcon />}
          iconPlacement="left"
          onClick={() => onChooseInvestmentAmount('first')}
          className={c.paymentItemButton}
        >
          {t('change_selection', 'Change')}
        </InlineButton>
      </div>

      <div className={c.paymentItemSeparator} />

      <div className={c.paymentItem}>
        <Typography variant="body2" textColor="greys.60" className={c.paymentItemTitle}>
          {t('monthly_payments', 'Monthly regular payments')}
        </Typography>
        <Currency
          value={monthlyAmount}
          valueSize="xxl"
          valueFontWeight="extraBold"
          codeSize="xxl"
          codeFontWeight="extraBold"
          valueClassName={c.currency}
          codeClassName={c.currency}
        />
        <InlineButton
          variant="underline"
          customIcon={<PencilIcon />}
          iconPlacement="left"
          onClick={() => onChooseInvestmentAmount('monthly')}
          className={c.paymentItemButton}
        >
          {t('change_selection', 'Change')}
        </InlineButton>
      </div>
    </Card>
  );
};

export default PaymentCard;

